import React from 'react'
import "./landing.css"
import "./landingResponsive.css"
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Scroller from './Scroller/scroller';

import Carousel1 from './Images/Carousel1.webp';
import Carousel2 from './Images/Carousel2.webp';
import Carousel3 from './Images/Carousel3.webp';

import Foto1 from "./Images/AppearImages/Foto1.webp"
import Foto2 from "./Images/AppearImages/Foto2.webp"
import Foto3 from "./Images/AppearImages/Foto3.webp"
import Foto4 from "./Images/AppearImages/Foto4.webp"


import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { ColorRing } from 'react-loader-spinner';
import { InstagramEmbed } from 'react-social-media-embed';

function Landing() {  

    //INVIO EMAIL CON CONTROLLO DEL FORM
    const form = useRef();
    
    const [errors, setErrors] = useState({
        nome: false,
        cognome: false,
        email: false,
        messaggio: false,
        privacy: false
    });

    const inputRefs = [
        useRef(null), // ref for nome
        useRef(null), // ref for cognome
        useRef(null), // ref for email
        useRef(null), // ref for messaggio
        useRef(null), // ref for privacy
    ];

    const [isLoading, setLoadingActive] = useState(false)
    const [isMessageSent, setMessageSent] = useState(false)
    const [privacyCheck, setPrivacyCheck] = useState(false)
    const [privacyInfo, setPrivacyInfo] = useState(false)

    const sendEmail = (e) => {
        e.preventDefault();

        const newErrors = {};
    
        inputRefs.forEach((ref, index) => {
            const value = ref.current.value.trim();
            const fieldId = ref.current.id;
            newErrors[fieldId] = value === '' || privacyCheck === false;
        });

        setErrors(newErrors);
        const hasErrors = Object.values(newErrors).some((error) => error);

        if (!hasErrors) {
            setLoadingActive(true)
            // Form submission logic here
            emailjs.sendForm('service_1sdy2dq', 'template_xtzsyoc', form.current, 'b5fsPJLt_FRNIzG-8')
                .then((result) => {
                    console.log(result.text);
                    console.log("message sent");
                    setLoadingActive(false);
                    setMessageSent(true);
                }, (error) => {
                    console.log(error.text);
            });
        } else {
            // Focus on the first input field with an error
            const firstErrorField = Object.keys(newErrors).find((field) => newErrors[field]);
            inputRefs.find((ref) => ref.current.id === firstErrorField).current.focus();
        }
    };

    //SCROLL ON X POSITION AFTER CLICK ON A LINK MENU
     const handleMenuClick = (id) => {
        const targetElement = document.getElementById(id);

        if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: elementPosition - 80,
                behavior: 'smooth',
              });        }
    };

    //SCROLL IMMAGINI NOVITA' E NAVBAR FIXED
    const [isNotchVisible, setNotchVisible] = useState(false)
    const [firstImage, setFirstImage] = useState(false)
    const [secondImage, setSecondImage] = useState(false)
    const [thirdImage, setThirdImage] = useState(false)
    const [fourthImage, setFourthImage] = useState(false)
    const [smallImages, setSmallImages] = useState(false)

    useEffect(() =>{
        const handleScroll = () => {
            if (window.scrollY < 150) {
                setNotchVisible(false)
            }

            if (window.scrollY >= 100) {
                setNotchVisible(true)
            }

            const img1 = document.getElementById('img1').getBoundingClientRect()
            const img2 = document.getElementById('img2').getBoundingClientRect()
            const img3 = document.getElementById('img3').getBoundingClientRect()
            const img4 = document.getElementById('img4').getBoundingClientRect()
            if(window.innerHeight <= img1.bottom) {
                setFirstImage(false);
            }

            if(window.innerHeight > img1.top) {
                setFirstImage(true);
            }

            if(window.innerHeight <= img2.bottom) {
                setSecondImage(false);
            }

            if(window.innerHeight > img2.top) {
                setSecondImage(true);
            }

            if(window.innerHeight <= img3.bottom) {
                setThirdImage(false);
            }

            if(window.innerHeight > img3.top) {
                setThirdImage(true);
            }

            if(window.innerHeight <= img4.bottom) {
                setFourthImage(false);
            }

            if(window.innerHeight > img4.top) {
                setFourthImage(true);
            }

            const imagesContainer = document.getElementById('small-images-container').getBoundingClientRect().top
            if (window.scrollY <= ((imagesContainer + window.pageYOffset) - 80) && ((imagesContainer + window.pageYOffset) <= (imagesContainer + window.pageYOffset) + 80) ){
              setSmallImages(true)

              setTimeout(() => {
                setFirstImage(true);
              }, 0);
              setTimeout(() => {
                setSecondImage(true);
              }, 1000);
              setTimeout(() => {
                setThirdImage(true);
              }, 2000);
              setTimeout(() => {
                setFourthImage(true);
              }, 3000);
            }
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
          };
    }, []); 
 

    //TO CLOSE EMAIL POPUP
    const closeEmailPopup = () => {
        setMessageSent(false);
        window.location.reload();
    };

  return (
    <div id="begin" className='landing-container'>
        <div className='navbar-container'>
            <div className='logo-container' onClick={() => handleMenuClick("begin")}></div>

            <div className='menu-container'>
                <p className='link' onClick={() => handleMenuClick("novita")}>Novità</p>
                <p className='link' onClick={() => handleMenuClick("streetwear")}>La Casa dello Streetwear</p>
                <p className='link' onClick={() => handleMenuClick("prodotti")}>I nostri prodotti</p>
                <p className='link' onClick={() => handleMenuClick("contatti")}>Contatti</p>
            </div>
        </div>

        <div className={isNotchVisible ? 'navbar-notch-container visible' : 'navbar-notch-container'}>
            <div className='logo-container' onClick={() => handleMenuClick("begin")}></div>

            <div className='menu-container'>
                <p className='link' onClick={() => handleMenuClick("novita")}>Novità</p>
                <p className='link' onClick={() => handleMenuClick("streetwear")}>La Casa dello Streetwear</p>
                <p className='link' onClick={() => handleMenuClick("prodotti")}>I nostri prodotti</p>
                <p className='link' onClick={() => handleMenuClick("contatti")}>Contatti</p>
            </div>
        </div>

        <div className='carosello-container'>
            <Carousel autoPlay interval={3000} infiniteLoop showStatus={false}  showThumbs={false}>
                <div>
                    <img className='foto1-immagine-scorrevole' src={Carousel2}/>
                </div>
                <div>
                    <img className='foto2-immagine-scorrevole' src={Carousel3}/>
                </div>
                <div>
                    <img className='foto3-immagine-scorrevole' src={Carousel1}/>
                </div>
            </Carousel>
        </div>

        <p id="novita" className='novita-text'>Novità</p>

        <div id='small-images-container' className={smallImages ? 'small-images-container scroll' : 'small-images-container'}>
            <div id="img1" className={firstImage ? 'img1 scroll' : 'img1'}><img src={Foto1}/></div>
            <div id="img2" className={secondImage ? 'img2 scroll' : 'img2'}><img src={Foto2}/></div>
            <div id="img3" className={thirdImage ? 'img3 scroll' : 'img3'}><img src={Foto3}/></div>
            <div id="img4" className={fourthImage ? 'img4 scroll' : 'img4'}><img src={Foto4}/></div>
        </div>

        <div className='novita-text-container'>
            <p className='novita-description-text'>
                "AREA287 nasce dall'idea di dare un abito perfetto alla tua personalità"
            </p>
        </div>
           
        <p id="streetwear" className='link2-text'>La Casa dello Streetwear</p>

        <div className='link2-images-container'>
            <div className='image1-link2'></div>
            <div className='image2-link2'></div>
        </div>

        <div className='link2-descprition-container'>
            <p className='image1-text-link2'>
            Più di un semplice negozio AREA287 
            vuole essere il luogo in cui dare spazio alla 
            creatività e alla diversità!
            </p>

            <p className='image2-text-link2'>
            Dal lavoro all'aperitivo, ci impegniamo a 
            scegliere accuratamente tutti i nostri capi 
            per offrirvi costanti novità e outfit da sogno
            </p>
        </div>

        <p id="prodotti" className='nostri-prodotti-text'>I nostri prodotti</p>
        <div className='vestiario-container'>
            <div className='firstline-products'>
                <div  className='insta-post-container'>
                    <InstagramEmbed  className='insta-post' url="https://www.instagram.com/p/C2UPcQZskhJ/?img_index=1" />
                </div>
                <div  className='insta-post-container'>
                    <InstagramEmbed  className='insta-post' url="https://www.instagram.com/p/C0T07ccs5uV/?img_index=1" />
                </div>
            </div>
            <div className='secondline-products'>
                <div  className='insta-post-container'>
                    <InstagramEmbed  className='insta-post' url="https://www.instagram.com/p/C1b8_j1sA3g/?img_index=1" />
                </div>
                <div  className='insta-post-container'>
                    <InstagramEmbed  className='insta-post' url="https://www.instagram.com/p/C0e3FBeLSdW/?img_index=1" /> 
                </div>  
            </div>
            <div className='small-screen-products'>
                <InstagramEmbed  className='insta-post' url="https://www.instagram.com/p/C0T07ccs5uV/?img_index=1" /> 
            </div>
        </div>

        <p id="prodotti" className='prodotti-text'>Le scarpe più ricercate</p>
        <div className='prodotti-container'>
            <div className='products-components-container'>
                <Scroller />
            </div>
        </div>

        <div id="contatti" className='footer-container'>
            <div className='write-me-container'>
                <form className='form-write-me' onSubmit={sendEmail} ref={form}>
                    <div className='inline-input'>
                        <input 
                            type='text' 
                            id='nome'
                            ref={inputRefs[0]}
                            name="user_name"
                            className={`nome ${errors.nome ? 'error' : ''}`}                       
                            placeholder='Nome'
                        />
                        <input 
                            type='text' 
                            id='cognome'
                            ref={inputRefs[1]}
                            name="user_surname"
                            className={`cognome ${errors.cognome ? 'error' : ''}`}                           
                            placeholder='Cognome'
                        />
                    </div>
                    <div className='single-input'>
                        <input 
                            type='text' 
                            id='email'
                            ref={inputRefs[2]}
                            name="user_email"
                            className={`email ${errors.email ? 'error' : ''}`}                           
                            placeholder='Email'
                        />
                        <input 
                            type='text' 
                            id='messaggio'
                            ref={inputRefs[3]}
                            name='messaggio' 
                            className={`messaggio ${errors.messaggio ? 'error' : ''}`}                            
                            placeholder='Messaggio'
                        />
                        <input type='text' id='numero' name='user_number' className='numero' placeholder='Numero di telefono (opzionale)' />
                    </div>
                    
                    <div className='privacy-container'>
                        <input 
                            type='checkbox' 
                            id='privacy'
                            ref={inputRefs[4]}
                            name='privacy' 
                            className={`privacy ${errors.privacy ? 'error' : ''}`}
                            onClick={() => setPrivacyCheck(true)}                            
                        />
                        <p className='privacy-text' onClick={() => setPrivacyInfo(true)}>Accetto l'informativa sulla privacy</p>

                        { privacyInfo ?
                            <div className='popup-privacy-container'>
                                <div className='informativa-title-container'>
                                    <p className='informativa-title'>Informativa Privacy</p>
                                </div>
                                <div className='informativa-contentuto'>
                                    <div className='sezione-container'>
                                        <div className='contenuto-title'>
                                            <p>Raccolta e Trattamento dei Dati Personali</p>
                                        </div>
                                        <div className='contenuto-text'>
                                            <p>Attraverso il modulo presente su questo sito, raccogliamo le seguenti informazioni personali:<br></br>
                                                - Nome <br></br>
                                                - Cognome <br></br>
                                                - Email <br></br>
                                                - Numero di telefono (opzionale)
                                            </p>
                                        </div>
                                    </div>
                                    <div className='sezione-container'>
                                        <div className='contenuto-title'>
                                            <p>Scopo della Raccolta dei Dati</p>
                                        </div>
                                        <div className='contenuto-text'>
                                            <p>La raccolta dei dati è finalizzata all'invio di un'email al negozio Area287.<br></br> I dati verranno utilizzati per consentire a Area287 di rispondere ai dubbi espressi nella email.</p>
                                        </div>
                                    </div>
                                    <div className='sezione-container'>
                                        <div className='contenuto-title'>
                                            <p>Condivisione dei Dati</p>
                                        </div>
                                        <div className='contenuto-text'>
                                            <p>Non utilizziamo un database e le email contenenti i dati raccolti <br></br>saranno inviate direttamente a Area287 tramite Gmail.</p>
                                        </div>
                                    </div>
                                    <div className='sezione-container'>
                                        <div className='contenuto-title'>
                                            <p>Conversazione dei Dati</p>
                                        </div>
                                        <div className='contenuto-text'>
                                            <p>Non conserviamo i dati personali raccolti tramite il modulo.</p>
                                        </div>
                                    </div>
                                    <div className='sezione-container'>
                                        <div className='contenuto-title'>
                                            <p>Base Legale per il Trattamento dei Dati</p>
                                        </div>
                                        <div className='contenuto-text'>
                                            <p>Il trattamento dei dati avviene sulla base del consenso esplicito <br></br>dell'utente, ottenuto mediante il click di una checkbox nel modulo.</p>
                                        </div>
                                    </div>
                                    <div className='sezione-container'>
                                        <div className='contenuto-title'>
                                            <p>Diritti dell'Utente</p>
                                        </div>
                                        <div className='contenuto-text'>
                                            <p>Gli utenti hanno il diritto di revocare il consenso in qualsiasi momento.<br></br> Inoltre, possono richiedere l'accesso, la correzione o la cancellazione<br></br> dei propri dati personali inviando <br></br>una richiesta a <span className='hidev-email'>hidevgroup23@gmail.com</span>.</p>
                                        </div>
                                    </div>
                                    <div className='sezione-container'>
                                        <div className='contenuto-title'>
                                            <p>Sicurezza dei Dati</p>
                                        </div>
                                        <div className='contenuto-text'>
                                            <p>Non sono state implementate misure di sicurezza<br></br> specifiche in quanto i dati vengono inviati a Area287 tramite Gmail.</p>
                                        </div>
                                    </div>
                                    <div className='sezione-container'>
                                        <div className='contenuto-title'>
                                            <p>Opzionalità della Raccolta dei Dati</p>
                                        </div>
                                        <div className='contenuto-text'>
                                            <p>La compilazione del modulo e la fornitura dei dati sono opzionali.<br></br> Gli utenti possono contattare Area287 utilizzando <br></br> le vie di comunicazione alternative presenti sul sito.</p>
                                        </div>
                                    </div>
                                    <div className='chiudi-privacy-container' onClick={() => setPrivacyInfo(false)}>
                                        <p>Chiudi</p>
                                    </div>
                                </div>
                            </div>
                            :
                            <div></div>
                        }
                    </div>

                    <input type='submit' id='invia' className='invia' value='Scrivimi!'></input>
                </form>
            </div>

            {isLoading === true && (
                <div className='overlay'>
                    <div className='spinner'>
                    <ColorRing
                        colors={['white', 'white', 'white', 'white', 'white']}
                        />
                    </div>
                </div>
            )}

            {isMessageSent === true  && (
                <div  className='overlay'>
                    <div className="popup-message">
                        <i className="fa-solid fa-x" onClick={closeEmailPopup}></i>
                        <div className="circle">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <p className='text-message-popup'>Messaggio inviato correttamente!</p>
                        <p className='text-close-popup' onClick={closeEmailPopup}>Continua a navigare sul sito!</p>
                    </div>
                </div>
            )}
            
            <div className='social-map-container'>
                <div className='map-container'>
                    <a className='a-map' href="https://www.google.com/maps/place/Area+287/@43.6648172,10.6366523,17z/data=!3m1!4b1!4m6!3m5!1s0x132a75529ce1bfaf:0x5db9b5f48f2c472d!8m2!3d43.6648172!4d10.6392272!16s%2Fg%2F11ss54wx7f?entry=ttu" target='_blank'>
                        <p className='map-text'>Puoi trovarci qui!</p>
                        <i class="fa-solid fa-location-dot"></i>
                    </a>
                </div>
                <div className='social-container'>
                    <Link to='https://www.instagram.com/area.287/' target='_blank'><i class="fa-brands fa-instagram"></i></Link>
                    <Link to='https://www.facebook.com/profile.php?id=100090269723146' target='_blank'><i class="fa-brands fa-facebook"></i></Link>
                    <Link to='whatsapp://send?phone=3899852107'><i class="fa-brands fa-whatsapp"></i></Link>
                </div>
            </div>
            <div className="powered-container">
                <p className="powered-text"><a href='https://www.hi-dev.it' target='_blank'>@Powered by Hidev</a></p>
            </div>

        </div>

        

    </div>
  )
}

export default Landing